import type { SVGProps } from "react";
export interface Parcel01HeartIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Parcel01HeartIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Parcel01HeartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.875 2a1.125 1.125 0 0 1 2.25 0v4.875h8.263l.116.006a1.125 1.125 0 0 1 0 2.238l-.116.006H2.612a1.125 1.125 0 0 1 0-2.25h8.263z"
      />
      <path
        fill={color}
        d="M20.375 8.812c0-.25-.05-.496-.145-.724l-.11-.221-2.223-3.812a1.88 1.88 0 0 0-1.62-.93H7.724c-.667 0-1.284.354-1.62.93L3.88 7.867a1.9 1.9 0 0 0-.255.945V19c0 1.035.84 1.875 1.875 1.875h13c1.036 0 1.875-.84 1.875-1.875zm-6.417 1.563c.935 0 1.745.48 2.288 1.101.547.626.903 1.485.875 2.408l.001.002c-.041 1.401-.979 2.428-1.698 3.132-.49.48-.96.924-1.366 1.302l-.98.895a1.614 1.614 0 0 1-2.04.098l-.118-.097a78 78 0 0 1-2.347-2.198c-.719-.704-1.656-1.73-1.698-3.132v-.002a3.53 3.53 0 0 1 .875-2.408c.543-.622 1.354-1.102 2.29-1.102.865 0 1.5.308 1.958.689.458-.381 1.094-.689 1.96-.689Zm0 2.25a.77.77 0 0 0-.589.23 1.4 1.4 0 0 0-.2.259l-.157.294v.002q-.016.03-.033.057l-.017.03a1.1 1.1 0 0 1-.252.29q-.066.055-.14.102l-.015.009q-.032.019-.066.036-.06.027-.119.047l-.006.001a1 1 0 0 1-.256.053 1.1 1.1 0 0 1-.32-.014 1.1 1.1 0 0 1-.28-.087l-.067-.036-.014-.01a1 1 0 0 1-.142-.102q-.041-.035-.08-.075-.04-.039-.076-.08a1 1 0 0 1-.12-.177l-.023-.044v-.002c-.098-.202-.203-.399-.359-.553a.77.77 0 0 0-.587-.23c-.148 0-.378.084-.594.33-.185.213-.3.482-.319.748l-.003.112v.005l.018.16c.073.38.373.812 1.005 1.43.705.69 1.37 1.306 1.851 1.744a74 74 0 0 0 1.853-1.745l.25-.253c.539-.567.761-.968.772-1.336v-.005l-.002-.112a1.3 1.3 0 0 0-.32-.747c-.215-.247-.445-.331-.593-.332ZM22.625 19a4.125 4.125 0 0 1-4.125 4.125h-13A4.125 4.125 0 0 1 1.375 19V8.812c0-.73.194-1.448.563-2.08l2.222-3.81A4.13 4.13 0 0 1 7.724.874h8.553c1.467 0 2.823.78 3.562 2.046l2.224 3.812.13.24c.284.57.432 1.2.432 1.839z"
      />
    </svg>
  );
}
